import { CodeSubject } from 'civil-status/constants/code-subject-section';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ParentVM, SectionVM, DatiDichiarante } from 'civil-status/view-models/step-form';

export const transformerDatiDichiarante = (
  idEvento?: number,
  subject?: ParentVM,
  dataDead?: SectionVM
): DatiDichiarante | undefined => {
  if (!subject && !(dataDead && dataDead.configuration === ConfigurationType.BASEDECA)) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    comprensione:
      subject?.codeSubject === CodeSubject.UNICIV1 || subject?.codeSubject === CodeSubject.UNICIV2
        ? undefined
        : subject?.generality?.conditionsItem?.id?.toString() ||
          dataDead?.conditionsItem?.id?.toString() ||
          undefined,
    motivoImpedimento:
      subject?.codeSubject === CodeSubject.UNICIV1 || subject?.codeSubject === CodeSubject.UNICIV2
        ? undefined
        : subject?.generality?.reasonImpediment || dataDead?.reasonImpediment || undefined,
    datiEssenzialiProcura: subject?.generality?.attorney || undefined,
    procura:
      subject?.codeSubject === CodeSubject.PROC_MA
        ? '1'
        : subject?.codeSubject === CodeSubject.PROC_PA
        ? '2'
        : undefined,
    titoloDichiarante: subject?.generality?.rolo || undefined,
  };
};
